import {IFormaPagamento} from "@models/formaPagamento/IFormaPagamento.ts";
import {NavButton, NavButtonProps} from "@shared/custom/NavButton.tsx";
import {useFormaPagamento} from "@components/formaPagamento/hooks/useFormaPagamento.ts";

interface FormaPagtoInfoNavProps extends NavButtonProps<IFormaPagamento | number> {
    displayAntecipacao?: boolean
}

export function FormaPagtoInfoNav(props: FormaPagtoInfoNavProps) {
    const {useFormaPagamentoValue} = useFormaPagamento()

    const [value] = useFormaPagamentoValue(props.value)

    return (value != null &&
        <NavButton<IFormaPagamento> displayMode={'nome'}
                                    label={(v) =>
                                        props.label != null && props.label(v) + value?.isAntecipacao ? 'Antecipação' : ''}
                                    {...props}
                                    value={value}/>
    )
}

